<template>
<div class="point">
   <div class="body"></div>
  <div class="right"><div class="top"></div></div>
</div>
</template>

<script>
export default {
  name: "point"
}
</script>

<style scoped lang="less">
.point{
  height: 20px;
  display: flex;
  align-items: center;
}
.body{
  width: 12px;
  height: 12px;
  background: #354CFB;
}
.right{
  width: 10px;
  position: relative;
}
.top{
  border: 10px solid transparent;
  border-left: 10px solid #354CFB;
  width: 0;
  height: 0px;
}
</style>